// Display helpers for a single rack location entry (an element of an asset's
// `rackLocations`). Accepts the current snake_case shape, its camelCase form,
// and the legacy single `warehouse_location` / `rack_location` values still
// found in older replay logs.

export const getLocationNames = rackLocation => {
  const locations = rackLocation?.warehouse_locations || rackLocation?.warehouseLocations;
  if (Array.isArray(locations)) {
    return locations.map(location => location?.location_name || location?.locationName).filter(Boolean);
  }

  const legacy = rackLocation?.warehouse_location || rackLocation?.rack_location;
  const name = typeof legacy === "object" && legacy !== null ? legacy.location_name : legacy;
  return name ? [name] : [];
};

export const getMobileLocationName = rackLocation => {
  const mobileLocation = rackLocation?.mobile_warehouse_location || rackLocation?.mobileWarehouseLocation;

  if (typeof mobileLocation === "string") {
    return mobileLocation || null;
  }

  return mobileLocation?.location_name || mobileLocation?.locationName || null;
};

// "<pallet> - <rack>, <rack>", optionally suffixed with " (<sub_qty>)".
export const formatRackLocationLabel = (rackLocation, { includeQty = false, fallback = "" } = {}) => {
  const label =
    [getMobileLocationName(rackLocation), getLocationNames(rackLocation).join(", ")]
      .filter(Boolean)
      .join(" - ") || fallback;

  if (!includeQty) {
    return label;
  }

  const qty = `(${rackLocation?.sub_qty || 0})`;
  return label ? `${label} ${qty}` : qty;
};
